import Rx from 'rxjs/Rx';

export default class ContentService {
  constructor($http, host, $poller) {
    this.http = $http;
    this.host = host;
    this.$poller = $poller;
  }

  findOth(data) {
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: this.host + '/api/accounts/oth-bills',
      params: data
    }).then(
      (resp) => resp.data.results,
      (resp) => resp
    ));
  }

  getArticlesList() {
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: this.host + '/api/accounts/products-list'
    }).then(
      (resp) => resp.data.results,
      (error) => error
    ));
  }

  findSalesByProducts(data) {
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: this.host + '/api/accounts/sales-by-products',
      params: data
    }).then(
      (resp) => resp.data.results,
      (error) => error
    ));
  }

  findSalesReport(data) {
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: this.host + '/api/accounts/sales-report',
      params: data
    }).then(
      (resp) => resp.data.results,
      (error) => error
    ));
  }

  findSalesByVendor(data) {
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: this.host + '/api/accounts/sales-by-vendor',
      params: data
    }).then(
      (resp) => resp.data.results,
      (error) => error
    ));
  }

  findInvoice(data) {
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: this.host + '/api/accounts/all-bills',
      params: data
    }).then(
      (resp) => resp.data.invoices,
      (error) => error
    ));
  }

  getBackupList() {
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: this.host + '/api/accounts/backup-files'
    }).then(
      (resp) => resp.data.files,
      (error) => error
    ));
  }

  uploadBackup(backup) {
    return Rx.Observable.fromPromise(this.http({
      method: 'POST',
      url: this.host + '/api/accounts/backup-files',
      data: {file: backup}
    }));
  }

  deleteBackup(backupId) {
    return Rx.Observable.fromPromise(this.http({
      method: 'DELETE',
      url: this.host + '/api/accounts/backup-files/' + backupId
    }));
  }

  deleteMultiplesBackups(idList){
    return Rx.Observable.fromPromise(this.http({
      method: 'DELETE',
      url: this.host + '/api/accounts/backup-files',
      params: {deleted: idList.join()}
    }));
  }

  getDttsList(page) {
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: this.host + '/api/accounts/dtt-files',
      params: {
        page: page
      }
    }).then(
      (resp) => resp.data,
      (error) => error
    ));
  }

  uploadDtt(dtt) {
    return Rx.Observable.fromPromise(this.http({
      method: 'POST',
      url: this.host + '/api/accounts/dtts',
      data: {file: dtt}
    }));
  }

  getPOSList() {
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: this.host + '/api/accounts/point-of-sales'
    }).then(
      (resp) => resp.data.points_of_sales,
      (error) => error
    ));
  }

  registerPOS(pointOfSales) {
    return Rx.Observable.fromPromise(this.http({
      method: 'POST',
      url: this.host + '/api/accounts/point-of-sales',
      data: {
        name: pointOfSales.name,
        number: pointOfSales.number,
        site_number: pointOfSales.site_number,
        port_number: pointOfSales.port_number,
        ip_address: pointOfSales.ip_address
      }
    }).then(
      (resp) => resp.data,
      (resp) => resp
    ));
  }

  changePOS(pointOfSales) {
    return Rx.Observable.fromPromise(this.http({
      method: 'PUT',
      url: this.host + '/api/accounts/point-of-sales/' + pointOfSales.id,
      data: {
        id: pointOfSales.id,
        name: pointOfSales.name,
        number: pointOfSales.number,
        site_number: pointOfSales.site_number,
        port_number: pointOfSales.port_number,
        ip_address: pointOfSales.ip_address
      }
    }));
  }

  deletePOS(posId) {
    return Rx.Observable.fromPromise(this.http({
      method: 'DELETE',
      url: this.host + '/api/accounts/point-of-sales/' + posId
    }));
  }

  getNcfList() {
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: this.host + '/api/accounts/invoice-ncf'
    }).then(
      (resp) => resp.data.invoice_ncfs,
      (error) => error
    ));
  }

  registerNCF(ncfInvoice) {
    return Rx.Observable.fromPromise(this.http({
      method: 'POST',
      url: this.host + '/api/accounts/invoice-ncf',
      data: {
        description: ncfInvoice.description,
        sequence: ncfInvoice.sequence
      }
    }).then(
      (resp) => resp.data,
      (resp) => resp
    ));
  }

  changeNCF(ncfInvoice) {
    return Rx.Observable.fromPromise(this.http({
      method: 'PUT',
      url: this.host + '/api/accounts/invoice-ncf/' + ncfInvoice.id,
      data: {
        id: ncfInvoice.id,
        description: ncfInvoice.description,
        sequence: ncfInvoice.sequence
      }
    }));
  }

  deleteNCF(ncfId) {
    return Rx.Observable.fromPromise(this.http({
      method: 'DELETE',
      url: this.host + '/api/accounts/invoice-ncf/' + ncfId
    }));
  }

  getClosingHour() {
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: this.host + '/api/accounts/closing-hour'
    }).then(
      (resp) => resp.data.closing_hour,
      (error) => error
    ));
  }

  updateClosingHour(hour) {
    return Rx.Observable.fromPromise(this.http({
      method: 'PUT',
      url: this.host + '/api/accounts/closing-hour',
      data: {hour: hour}
    }));
  }

  getInvoice(invoiceId) {
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: this.host + '/api/accounts/all-bills/' + invoiceId
    }).then(
      (resp) => resp.data,
      (resp) => resp
    ));
  }

  getOrders(invoiceId) {
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: this.host + '/api/accounts/invoices/' + invoiceId + '/orders'
    }).then(
      (resp) => resp.data.results,
      (resp) => resp
    ));
  }

  getOrderDetails(invoiceId, orderId) {
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: this.host + '/api/accounts/invoices/' + invoiceId + '/orders/' + orderId
    }).then(
      (resp) => resp.data.results,
      (resp) => resp
    ));
  }

  inviteUser(emails, permissions) {
    return Rx.Observable.fromPromise(this.http({
      method: 'POST',
      url: this.host + '/api/accounts/user-invitation',
      data: {emails: emails, permissions: permissions}
    }));
  }

  getAccountProfiles() {
      return Rx.Observable.fromPromise(this.http({
          method: 'GET',
          url: this.host + '/api/accounts/profiles'
      }).then(
          (resp) => resp.data.profiles,
          (resp) => resp
      ));
  }

  assignPerm(id, data){
    return Rx.Observable.fromPromise(this.http({
      method: 'PUT',
      url: `${this.host}/api/accounts/permissions/${id}`,
      data: data
    }).then(
      resp => resp.data,
      resp => resp
    ));
  }

  revokePerm(id, data){
    return Rx.Observable.fromPromise(this.http({
      method: 'DELETE',
      url: `${this.host}/api/accounts/permissions/${id}`,
      params: data
    }).then(
      resp => resp.data,
      resp => resp
    ));
  }

  deleteProfile(id){
    return Rx.Observable.fromPromise(this.http({
      method: 'DELETE',
      url: `${this.host}/api/accounts/profiles/${id}`
    }).then(
      resp => resp.data,
      resp => resp
    ));
  }

  getUserInvitations() {
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: `${this.host}/api/users/pending-invitations`
    }).then(
      (resp) => resp.data.invitations,
      (resp) => []
    ));
  }
  checkInvitations() {
    this.$poller.stopPolling(`${this.host}/api/users/pending-invitations`);
    return this.$poller.startPolling(`${this.host}/api/users/pending-invitations`, {}, {}, 60000);
  }
  stopCheckingInvitations() {
    this.$poller.stopPolling(`${this.host}/api/users/pending-invitations`);
  }

  acceptInvitation(data){
    return Rx.Observable.fromPromise(this.http({
      method: 'PUT',
      url: `${this.host}/api/users/pending-invitations`,
      data: data
    }).then(
      resp => resp.data,
      resp => resp
    ));
  }

  getAccountInvitations(){
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: `${this.host}/api/accounts/user-invitation`,
    }).then(
      resp => resp.data.invitations,
      resp => resp
    ));
  }

  cancelInvitation(data){
    return Rx.Observable.fromPromise(this.http({
      method: 'DELETE',
      url: `${this.host}/api/accounts/user-invitation`,
      params: data
    }).then(
      resp => resp.data,
      resp => resp
    ));
  }
  
  triggerDttProcess() {
    return Rx.Observable.fromPromise(this.http({
      method: 'PATCH',
      url: this.host + '/api/accounts/unprocessed-dtts'
    }).then(
      (resp) => resp.data,
      (resp) => resp.data
    ));
  }

  getAvailableClientKeys() {
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: this.host + '/api/accounts/available-client-keys'
    }).then(
      (resp) => resp.data.client_ids,
      (resp) => []
    ));
  }

  getCollectorsList(){
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: `${this.host}/api/accounts/collectors`
    }).then(
      (resp) => resp.data,
      (resp) => resp.data
    ));
  }

  registerCollector(data){
    return Rx.Observable.fromPromise(this.http({
      method: 'POST',
      url: `${this.host}/api/accounts/collectors`,
      data: data
    }).then(
      (resp) => resp.data,
      (resp) => resp.data
    ));
  }

  editCollector(data){
    return Rx.Observable.fromPromise(this.http({
      method: 'PUT',
      url: `${this.host}/api/accounts/collectors/${data.id}`,
      data: data
    }).then(
      (resp) => resp.data,
      (resp) => resp
    ));
  }

  deleteCollector(data){
    return Rx.Observable.fromPromise(this.http({
      method: 'DELETE',
      url: `${this.host}/api/accounts/collectors/${data.id}`
    }).then(
      (resp) => resp.data,
      (resp) => resp
    ))
  }

  observePOS(collector, pos){
    return Rx.Observable.fromPromise(this.http({
      method: 'POST',
      url: `${this.host}/api/accounts/collectors/${collector.id}/pos`,
      data: {
        pos_id: pos.id
      }
    }).then(
      resp => resp.data,
      resp => resp
    ));
  }

  unobservePOS(collector, pos){
    return Rx.Observable.fromPromise(this.http({
      method: 'DELETE',
      url: `${this.host}/api/accounts/collectors/${collector.id}/pos/${pos.id}`
    }).then(
      resp => resp.data,
      resp => resp
    ))
  }

  startCollector(collector){
    return Rx.Observable.fromPromise(this.http({
      method: 'PATCH',
      url: `${this.host}/api/accounts/collectors/${collector.id}`
    }).then(
      resp => resp.data,
      resp => resp
    ));
  }

  stopCollector(collector){
    return Rx.Observable.fromPromise(this.http({
      method: 'PATCH',
      url: `${this.host}/api/accounts/collectors/${collector.id}`
    }).then(
      resp => resp.data,
      resp => resp
    ));
  }

  collect(collector){
    return Rx.Observable.fromPromise(this.http({
      method: 'PUT',
      url: `${this.host}/api/accounts/collectors/collect-now/${collector.id}`
    }).then(
      resp => resp.data,
      resp => resp
    ));
  }

  collectAll(){
    return Rx.Observable.fromPromise(this.http({
      method: 'POST',
      url: `${this.host}/api/accounts/collectors/collect-now`
    }).then(
      resp => resp.data,
      resp => resp
    ));
  }

  getJournalFiles() {
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: `${this.host}/api/accounts/journal-files`
    }).then(
      resp => resp.data,
      resp => resp
    ));
  }

  processJournals() {
    return Rx.Observable.fromPromise(this.http({
      method: 'PATCH',
      url: `${this.host}/api/accounts/unprocessed-journals`
    }).then(
      resp => resp.data,
      resp => resp
    ));
  }

  getPrintedUnclosed(data) {
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: `${this.host}/api/accounts/printed-unclosed`,
      params: data
    }).then(
      resp => resp.data,
      resp => resp
    ));
  }

  getPaymentOnlyBills(data) {
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: `${this.host}/api/accounts/payment-only`,
      params: data
    }).then(
      resp => resp.data,
      resp => resp
    ));
  }

  downloadBackup(filename) {
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: `${this.host}/api/accounts/backup-files/${filename}`,
      responseType: 'arraybuffer'
    }));
  }

  downloadDTT(filename) {
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: `${this.host}/api/accounts/dtt-files/${filename}`,
      responseType: 'arraybuffer'
    }));
  }

  findClosingHourReport(data){
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: `${this.host}/api/accounts/daily-closing`,
      params: data
    }).then(
      resp => resp.data,
      resp => resp
    ));
  }

  findPrintedBillsReport(data){
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: `${this.host}/api/accounts/printed-bills`,
      params: data
    }).then(
      resp => resp.data,
      resp => resp
    ));
  }

  findSalesByCategory(data, fam_id){
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: `${this.host}/api/accounts/sales-by-category${fam_id ? '/'+fam_id : ''}`,
      params: data
    }).then(
      resp => resp.data,
      resp => resp
    ));
  }

  chooseLanguage(language){
    return Rx.Observable.fromPromise(this.http({
        method: 'PATCH',
        url: this.host + '/api/users',
        data: {language: language}
    }).then(
        (resp) => resp.data,
        (resp) => undefined
    ));
  }

  registerMaterial(data){
    return Rx.Observable.fromPromise(this.http({
      method: 'POST',
      url: `${this.host}/api/accounts/raw-materials`,
      data: data
    }).then(
      (resp) => resp.data,
      (resp) => resp
    ));
  }

  editMaterial(data, id){
    return Rx.Observable.fromPromise(this.http({
      method: 'PUT',
      url: `${this.host}/api/accounts/raw-materials/${id}`,
      data: data
    }).then(
      (resp) => resp.data,
      (resp) => resp
    ));
  }

  getAllMaterials(){
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: `${this.host}/api/accounts/raw-materials`
    }).then(
      (resp) => resp.data,
      (resp) => resp
    ));
  }

  changeMaterialExistence(data, id){
    return Rx.Observable.fromPromise(this.http({
      method: 'PATCH',
      url: `${this.host}/api/accounts/raw-materials/${id}`,
      data: data
    }).then(
      (resp) => resp.data,
      (resp) => resp
    ));
  }

  deleteMaterial(id){
    return Rx.Observable.fromPromise(this.http({
      method: 'DELETE',
      url: `${this.host}/api/accounts/raw-materials/${id}`
    }).then(
      (resp) => resp.data,
      (resp) => resp
    ));
  }

  associateArticle(mid, aid, data){
    return Rx.Observable.fromPromise(this.http({
      method: 'POST',
      url: `${this.host}/api/accounts/raw-materials/${mid}/${aid}`,
      data: data
    }).then(   
      (resp) => resp.data,
      (resp) => resp
    ));
  }

  adjustArticleAmount(mid, aid, data){
    return Rx.Observable.fromPromise(this.http({
      method: 'POST',
      url: `${this.host}/api/accounts/raw-materials/${mid}/${aid}`,
      data: data
    }).then(   
      (resp) => resp.data,
      (resp) => resp
    ));
  }

  disassociateArticle(mid, aid){
    return Rx.Observable.fromPromise(this.http({
      method: 'DELETE',
      url: `${this.host}/api/accounts/raw-materials/${mid}/${aid}`,
    }).then(
      (resp) => resp.data,
      (resp) => resp
    ));
  }

  getSalesByTag(data, sid){
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: `${this.host}/api/accounts/sales-by-tag${ sid ? `/${sid}` : '' }`,
      params: data
    }).then(resp => resp.data, resp => resp));
  }

  getSalesByNCF(dateFrom, dateTo){
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: `${this.host}/api/accounts/sales-by-ncf`,
      params: {
        date_to: dateTo,
        date_from: dateFrom
      }
    }).then(resp => resp.data, resp => resp));
  }

  getCashiersBySearchTerm(term) {
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: `${this.host}/api/accounts/cashiers`,
      params: { q: term }
    }).then(resp => resp.data.rows, resp => []));
  }

  getCategoriesBySearchTerm(term) {
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: `${this.host}/api/accounts/categories`,
      params: { q: term }
    }).then(resp => resp.data.rows, resp => []));
  }

  getTagsBySearchTerm(term) {
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: `${this.host}/api/accounts/tags`,
      params: { q: term }
    }).then(resp => resp.data.rows, resp => []));
  }

  getSalesDetails(dateFrom, dateTo, tablesRanges, cashiers, categories, tags) {
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: `${this.host}/api/accounts/sales-details-report`,
      params: {
        date_from: dateFrom,
        date_to: dateTo,
        table_ranges: JSON.stringify(tablesRanges),
        cashiers: JSON.stringify(cashiers),
        categories: JSON.stringify(categories),
        tags: JSON.stringify(tags)
      }
    }).then(resp => resp.data.rows, resp => []));
  }

  getAccountHandies(){
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: `${this.host}/api/accounts/handies`
    }).then(
      resp => resp.data.handies,
      resp => resp
    ));
  }

  registerHandy(data){
    return Rx.Observable.fromPromise(this.http({
      method: 'POST',
      url: `${this.host}/api/accounts/handies`,
      data: data
    }).then(
      resp => resp.data,
      resp => resp
    ));
  }

  countAccountPointOfSales() {
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      params: { just_count: true },
      url: `${this.host}/api/accounts/point-of-sales`
    }).then(resp => (resp.data || {}).points_of_sales || 0, resp => 0));
  }
  countAccountHandies() {
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      params: { just_count: true },
      url: `${this.host}/api/accounts/handies`
    }).then(resp => (resp.data || {}).handies || 0, resp => 0));
  }

}

ContentService.$inject = ['$http', 'host', '$poller'];



// WEBPACK FOOTER //
// ./src/app/services/content.service.js